import React from "react";
import { ListView } from "../../components/ListView";
import { IncomingTasksFields } from "../../context/Forms";
const CompletedCase = () => {
  return (
    <ListView
      notFoundTitle="global_not_found"
      withPagination
      withSearch
      title="completed_case"
      searchable_fields={["name"]}
      withShow
      controller="incoming_task/compeleted_cases"
      fields={IncomingTasksFields}
    />
  );
};
export default CompletedCase;
